export const ADMIN_ROLE_CODE = 'ADMIN';

export function isAdminRole(code: string | null | undefined): boolean {
  return code === ADMIN_ROLE_CODE;
}

export const SEARCH_DEBOUNCE_MS = 200;

// Result cap for the compact type-ahead employee pickers (share/sign/upload drawers,
// calendar filter, global top-bar search). Centralised so every picker truncates alike.
export const EMPLOYEE_PICKER_LIMIT = 8;
export const NO_TIME_OFF_BALANCES_MSG = 'No time-off balances yet. Contact HR if this is unexpected.';
